import React from "react";
import { Grid, TextField, Typography, Box } from "@material-ui/core";

export const PLAN_CAMPAIGN_DEFAULTS = {
  maxWhatsappGroupCampaigns: -1,
  maxTelegramGroupCampaigns: -1,
  maxWhatsappGroupsPerCampaign: -1,
  maxTelegramGroupsPerCampaign: -1,
  maxWhatsappCampaignContacts: -1,
  maxTelegramCampaignContacts: -1,
  maxStatusCampaignsPerDay: 1,
  maxTelegramStatusCampaignsPerDay: 1,
};

export const planCampaignValues = (plan = {}) => Object.fromEntries(
  Object.entries(PLAN_CAMPAIGN_DEFAULTS).map(([key, fallback]) => [key, plan[key] ?? fallback])
);

const CHANNELS = [
  { name: "WhatsApp", prefix: "Whatsapp", statusKey: "maxStatusCampaignsPerDay" },
  { name: "Telegram", prefix: "Telegram", statusKey: "maxTelegramStatusCampaignsPerDay" },
];

export default function PlanCampaignLimits({ values, setFieldValue }) {
  return (
    <Grid item xs={12}>
      <Typography variant="h6">Límites de campañas por canal</Typography>
      <Typography variant="body2" color="textSecondary">
        Los cupos de campañas se comparten entre las cuentas de la empresa de cada canal. Los estados e historias se cuentan por cuenta y por día.
        Usa -1 para sin límite y 0 para deshabilitar. Estados e historias: de 0 a 5.
      </Typography>
      {CHANNELS.map(({ name, prefix, statusKey }) => (
        <Box key={name} mt={2}>
          <Typography variant="subtitle1">{name}</Typography>
          <Grid container spacing={2}>
            {[
              [`max${prefix}GroupCampaigns`, "Campañas activas/programadas a grupos", "Las pausadas y finalizadas no ocupan cupo."],
              [`max${prefix}GroupsPerCampaign`, "Grupos/canales por campaña", "Destinos distintos por campaña, sin contar miembros."],
              [`max${prefix}CampaignContacts`, "Contactos por campaña masiva", "Máximo de contactos de la lista seleccionada."],
              [statusKey, name === "Telegram" ? "Historias por cuenta al día" : "Estados por cuenta al día", "Máximo 5. Cada cuenta tiene su propio cupo."],
            ].map(([key, label, helperText]) => {
              const status = key === statusKey;
              const value = values[key] ?? PLAN_CAMPAIGN_DEFAULTS[key];
              const invalid = !Number.isInteger(Number(value)) || Number(value) < (status ? 0 : -1) || (status && Number(value) > 5);
              return (
                <Grid item xs={12} sm={6} key={key}>
                  <TextField
                    fullWidth variant="outlined" size="small" type="number" id={`plan-${key}`} name={key} label={label}
                    value={value} inputProps={{ min: status ? 0 : -1, ...(status ? { max: 5 } : {}), step: 1 }}
                    onChange={event => setFieldValue(key, event.target.value)} error={invalid}
                    helperText={invalid ? "Introduce un número entero dentro del rango permitido." : helperText}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      ))}
    </Grid>
  );
}
